module.exports = __webpack_public_path__ + "static/media/background.3e2da5d6.svg";